import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import {
  ActivateDeactivateCommands,
  Feature,
  FeatureNames,
  OperatingProgramProperties,
} from '@vi-iot/client';

import { InstallationFeaturesStore } from '@store';

import {
  HeatingPanelService,
  HEATING_PROGRAMS,
} from '../../../temperature-schedule-manager/heating-panel/heating-panel.service';

@Component({
  selector: 'app-eco-mode-panel',
  templateUrl: './eco-mode-panel.component.html',
  styleUrls: ['./eco-mode-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EcoModePanelComponent implements OnInit {
  @Input() circuitId: string;

  eco$: Observable<Feature<OperatingProgramProperties, ActivateDeactivateCommands>>;

  constructor(
    public heatingPanelService: HeatingPanelService,
    private installationFeaturesStore: InstallationFeaturesStore
  ) {}

  ngOnInit(): void {
    this.eco$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuitOperatingProgram(this.circuitId, HEATING_PROGRAMS.ECO)
    );
  }
}
